import { useCallback, useMemo } from 'react'

import { EmptyProvider } from '@/components/ui/empty/empty-provider.tsx'
import { EmptyTableContent } from '@/components/ui/empty/empty-table-content.tsx'
import { DataTable } from '@/components/ui/table/controlled-pagination/DataTable'
import { compareTimes } from '@/modules/creator-settings/rebill-messages/helpers/time.ts'
import { buildColumns } from '@/modules/expiring-fans/components/tables/messages/columns.tsx'
import type { ExpiringFansMessage } from '@/modules/expiring-fans/types.ts'

interface Props {
  messages: ExpiringFansMessage[]
  handleToggleChange: (id: number, value: boolean) => Promise<unknown>
  deleteMessage: (id: number) => Promise<unknown>
}
export const ExpiringFansMessagesTable = ({
  messages,
  handleToggleChange,
  deleteMessage,
}: Props) => {
  const renderEmpty = useCallback(
    () => (
      <EmptyTableContent>
        It looks like you don&#39;t have any messages created yet, click on the{' '}
        <span className="text-pointer text-primary-500">Add Message</span>{' '}
        button to do so.
      </EmptyTableContent>
    ),
    [],
  )

  const columns = useMemo(
    () =>
      buildColumns({
        toggleMessage: handleToggleChange,
        deleteMessage,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleToggleChange],
  )
  const tableRebillData = useMemo(
    () =>
      messages.sort((a, b) => compareTimes(a.timeframeStart, b.timeframeStart)),
    [messages],
  )

  return (
    <EmptyProvider render={renderEmpty}>
      <DataTable
        tbodyMinHeight={false}
        hasActionColumn
        columns={columns}
        data={tableRebillData}
      />
    </EmptyProvider>
  )
}
